import React, { useEffect, useState, useCallback } from 'react';
import { useFormik } from 'formik';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import appActions from '../../../appActions';
import moment from 'moment';
import { Calendar } from 'primereact/calendar';
import { InputSwitch } from 'primereact/inputswitch';
import storage from '../../../utils/storage';
import { InputNumber } from 'primereact/inputnumber';
import { ToggleButton } from 'primereact/togglebutton';
import { Divider } from 'primereact/divider';
import { Dialog } from 'primereact/dialog';
import { Chip } from 'primereact/chip';
import { actionTypeOptions, completionOptions, isAdminRole, recurrenceOptions, dateTimeFormat } from '../../../utils/mics';
import TaskFormIcon from '../../../components/TaskFormIcon';
import ReminderRecurrenceForm from './ReminderRecurrenceForm';
import UserAutoCompleteInput from '../../../components/UserAutoCompleteInput';
import SiteAutoCompleteInput from '../../../components/SiteAutoCompleteInput';
import { MultiSelect } from 'primereact/multiselect';
import { ConfirmDialog } from 'primereact/confirmdialog';
import axios from 'axios';

const configOpiton = window && window.config;

const TaskFileUploadForm = (props) => {
    const { record, userRole } = props;
    const dispatch = useDispatch();
    const [attachment, setAttachment] = useState(null);
    const [allDay, setAllDay] = useState(false);
    const [rVisible, setRvisible] = useState(false);
    const [reminderRecurrenceVisible, setReminderRecurrenceVisible] = useState(false);
    const [taskRecurrence, setTaskRecurrence] = useState(null);
    const [reminderPropsRecurrence, setReminderPropsRecurrence] = useState(null);
    const [timeFromToAllDayError, setTimeFromToAllDayError] = useState(false);
    const [selfAssign, setSelfAssign] = useState(false);
    const currentUser = JSON.parse(storage.get('loginUser'));
    const [confirmUpdateDialog, setConfirmUpdateDialog] = useState(false);
    const [confirmUpdateMessage, setConfirmUpdateMessage] = useState('');
    const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false);
    const [confirmDeleteMessage, setConfirmDeleteMessage] = useState('');
    const [siteGroupMultiSelect, setSiteGroupMultiSelect] = useState([]);
    const [remindDateState, setRemindDateState] = useState(null);
    const [remindTimeState, setRemindTimeState] = useState(null);
    const [recurrenceMessage, setRecurrenceMessage] = useState('');
    const [recurrenceErrorMsg, setRecurrenceErrorMsg] = useState('');

    const priorityOptions = useSelector((state) => state.common.priorityList);
    const reminderOptions = useSelector((state) => state.common.reminderList);
    const siteGroupOptions = useSelector((state) => state.common.siteGroupList);
    const timeZoneOptions = useSelector((state) => state.common.timeZoneList);

    // const handleFileUpload = (e) => {
    //     setAttachment(e.target.files[0]);
    // };

    useEffect(() => {
        if(record) {
            if(record.taskDateTime && record.dueDateTime) {
                const taskDateTime = moment(record.taskDateTime, dateTimeFormat);
                const dueDateTime = moment(record.dueDateTime, dateTimeFormat);

                if (taskDateTime.hours() === 0 && taskDateTime.minutes() === 0 && dueDateTime.hours() === 23 && dueDateTime.minutes() === 59) {
                    setAllDay(true);
                } else {
                    setAllDay(false);
                }
                
            }

            setRemindDateState(record?.reminderOn 
                        ? moment(record.reminderOn, dateTimeFormat).toDate()  : null);
            
            setRemindTimeState(record?.reminderOn 
                        ? moment(record.reminderOn, dateTimeFormat).toDate()  : null);
                        
            // if(record?.taskRecurrence && Object.keys(record.taskRecurrence).length > 0) {
            //     setTaskRecurrence(record.taskRecurrence);
            //     handleRecurrenceMessage(record.taskRecurrence);
            // }
            
            if(record?.reminderProps && Object.keys(record.reminderProps).length > 0) {
                setReminderPropsRecurrence(record.reminderProps);
                handleRecurrenceMessage(record.reminderProps);
            }

            if(record?.assignType === 'site-group') {
                setSiteGroupMultiSelect(record?.assignedTo ? record?.assignedTo?.split(',') : [])
            }
        }
    }, [ record ])

    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const fileText = await convertFileToBase64(file);
            const fileData = {
                fileName: file.name,
                fileText: fileText.split(',')[1], // Remove the "data:" prefix
            };
            setAttachment(fileData)
        }
    };

    const handleUpdateFormik = () => {
        // formik.handleSubmit();
        setConfirmUpdateDialog(false);
        callUpdateMessageApi(formik.values);
    };

    const handleDelete = () =>{
        if(record?.id){
            dispatch(appActions.TASK_DELETE_REQUEST({id : record?.id}));
            props.hideDialog();
        }
    }

    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const formik = useFormik({
        initialValues: {
            taskGroup: 'site',
            assignType: record?.assignType || 'user',
            // taskType: record?.taskType ? record?.taskType?.split(',') : [],
            taskType: '',
            title: record?.title || '',
            subject: record?.subject || '',
            description: record?.description || '',
            remark: record?.remark || '',
            taskDate: record && record.taskDateTime
                        ? moment(record.taskDateTime, dateTimeFormat).toDate()
                        : '',
            dueDate: record && record.dueDateTime
                    ? moment(record.dueDateTime, dateTimeFormat).toDate()
                    : '',
            dueDateTime: '',
            repeatType: '',
            priority: record?.priority || '',
            assignedTo: record?.assignedTo || '',
            assignedBy: record?.assignedBy || '',
            assignedDateTime: '',
            status: '',
            timeFrom: record && record.taskDateTime
                        ? moment(record.taskDateTime, dateTimeFormat).toDate()
                        : '',
            timeTo: record && record.dueDateTime
                    ? moment(record.dueDateTime, dateTimeFormat).toDate()
                    : '',
            timeZone: record?.timeZone || '',
            // attachmentRequired: record?.attachmentRequired || '',
            taskGroupCode: record?.taskGroupCode || '',
            siteId: record?.siteId || '',
            reminder: record && record.reminder ? record.reminder === 'Y' ? true : false : false,
            recurrence: record?.recurrence || 'N',
            reminderTime: record?.reminderTime || '',
            reminderOn: record?.reminderOn 
                            ? moment(record.reminderOn, dateTimeFormat).toDate() 
                            : '',
            actionBy: record?.actionBy || '',
            impact: record?.impact || '',
            lastUpdatedBy: storage?.get('userName'),
            remindDate: record?.reminderOn 
                        ? moment(record.reminderOn, dateTimeFormat).toDate() 
                        : '',
            remindTime: record?.reminderOn 
                        ? moment(record.reminderOn, dateTimeFormat).toDate() 
                        : '',
            reminderProps: record?.reminderProps || null,
            reminderRecurrence: record?.reminderRecurrence || 'N'
        },
        enableReinitialize: true,
        validate: (data) => {
            let errors = {};
            if (!data.taskDate) {
                errors.taskDate = 'Start Date is required.';
            }
            if (!data.dueDate) {
                errors.dueDate = 'End Date is required.';
            }
            if (!data.timeFrom) {
                errors.timeFrom = 'Start Time is required.';
            }
            if (!data.timeTo) {
                errors.timeTo = 'End Time is required.';
            }
            // if (!data.taskType) {
            //     errors.taskType = 'Task type is required.';
            // }
            if (!data.title) {
                errors.title = 'Title is required.';
            }
            if (!data.subject) {
                errors.subject = 'Subject is required.';
            }
            if (!data.assignedTo) {
                if(data.assignType !== 'site-all') {
                    errors.assignedTo = 'Assigned to is required.';
                }
            }
            if (!data.impact) {
                errors.impact = 'Impact is required.';
            }
            if (!data.description) {
                errors.description = 'Description is required.';
            }
            if (!data.priority) {
                errors.priority = 'Priority is required.';
            }
            // if (!data.attachmentRequired) {
            //     errors.attachmentRequired = 'Select attachment required';
            // }
            if (!data.reminderTime && data.reminder) {
                errors.reminderTime = 'Reminder at is required.';
            }
            // if (!data.reminderOn && data.reminder) {
            //     errors.reminderOn = 'Reminder date is required.';
            // }
            if (!data.assignType && data.assignType) {
                errors.assignType = 'Assign Type is required.';
            }
            if (!data.timeZone) {
                errors.timeZone = 'Time Zone is required.';
            }
            if(data.taskDate && data.dueDate) {
                const beforeTaskDate = moment(data.dueDate).isBefore(moment(data.taskDate));
                if(beforeTaskDate) {
                    errors.taskDate = 'Start Date must be before End Date.';
                }
                else {
                    const taskDate = moment(data.taskDate);
                    const timeFrom = moment(data.timeFrom, 'HH:mm');
                    const dueDate = moment(data.dueDate);
                    const timeTo = moment(data.timeTo, 'HH:mm');

                    // Combine date and time correctly without formatting to string
                    const taskDateTime = taskDate.set({
                        hour: timeFrom.hour(),
                        minute: timeFrom.minute()
                    });
                    const dueDateTime = dueDate.set({
                        hour: timeTo.hour(),
                        minute: timeTo.minute()
                    });

                    // Now you can use isAfter correctly
                    const afterStartTime = taskDateTime.isAfter(dueDateTime);
                    if(afterStartTime) {
                        errors.timeFrom = 'Start Time must be before End Time.';
                    }
                }
            }
            if(!remindDateState) {
                errors.remindDate = 'Remind Date is required.';
            }

            if(!remindTimeState) {
                errors.remindTime = 'Remind Time is required.';
            }
            if(remindDateState && remindTimeState) { 
                const afterDueDate = moment(remindDateState).isAfter(moment(data.dueDate));
                if(afterDueDate) {
                    errors.remindDate = 'Remind Date must not be before End Date.';
                }
                else {
                    const remindDate = moment(remindDateState);
                    const remindTime = moment(remindTimeState, 'HH:mm');
                    const dueDate = moment(data.dueDate);
                    const timeTo = moment(data.timeTo, 'HH:mm');

                        // Combine date and time correctly without formatting to string
                    const remindDateTime = remindDate.set({
                        hour: remindTime.hour(),
                        minute: remindTime.minute()
                    });
                    const dueDateTime = dueDate.set({
                        hour: timeTo.hour(),
                        minute: timeTo.minute()
                    });

                    // Now you can use isAfter correctly
                    const afterStartTime = remindDateTime.isAfter(dueDateTime);
                    if(afterStartTime) {
                        errors.remindTime = 'Remind Time must be before End Time.';
                    }

                }

            }

            // if(getFromToTimeOrAllDayErrorMessage()) {
            //     errors.timeFrom = 'Please fill up Time From and To or All day';
            // }
            return errors;
        },
        onSubmit: (values) => {
           
            handleConfirmUpdateDialog(values)
            
        },
    });

    const callUpdateMessageApi = (values) =>{
         //const timeFrom = moment(values.timeFrom).format('HH:mm') === 'Invalid date' ? '00:00' : moment(values.timeFrom).format('HH:mm');
            //const timeTo = moment(values.timeTo).format('HH:mm') === 'Invalid date' ? '23:59' : moment(values.timeTo).format('HH:mm');
            const taskDateTime = moment(values.taskDate).format('DD-MM-YYYY') +
                                ' ' +
                                moment(values.timeFrom).format('HH:mm:ss');
            const dueDateTime = moment(values.dueDate).format('DD-MM-YYYY') +
                                ' ' +
                                moment(values.timeTo).format('HH:mm:ss');
            const data = {
                ...values,
                id: record.id,
                taskDateTime: taskDateTime,
                dueDateTime: dueDateTime,
                reminderOn: moment(remindDateState).format('DD-MM-YYYY') +
                                    ' ' +
                                    moment(remindTimeState).format('HH:mm:ss'),
                lastUpdatedBy: storage?.get('userName')
            };
            
            if (attachment) {
                data['attachedFiles'] = [{"fileText": attachment.fileText }]
            }
            const completeData = {
                ...record,
                attachedFiles: data['attachedFiles'],
                endDateTime: moment().format(dateTimeFormat),
                // status: 'COMPLETED',
            }
            //handle change of values base on the forms
            completeData['lastUpdatedBy'] = data['lastUpdatedBy'];
            completeData['taskType'] = data['taskType'] ? data['taskType'].join(',') : '';
            if(data['assignType'] === 'site-all') {
                completeData['assignedTo'] = ''
            }
            else {
                completeData['assignedTo'] = data['assignedTo'];
            }
            completeData['assignType'] = data['assignType'];
            completeData['title'] = data['title'];
            completeData['subject'] = data['subject'];
            completeData['description'] = data['description'];
            completeData['taskDateTime'] = data['taskDateTime'];
            completeData['dueDateTime'] = data['dueDateTime'];
            completeData['priority'] = values['priority']
            completeData['impact'] = values['impact'];
            // completeData['actionBy'] = values['actionBy'];
            // completeData['attachmentRequired'] = values['attachmentRequired'];
            completeData['recurrence'] = values['recurrence'];
            completeData['remark'] = values['remark'];
            completeData['reminder'] = values['reminder'] === true ? 'Y' : 'N';
            completeData['reminderOn'] = data['reminderOn'];
            completeData['reminderEmail'] = 'Y'; //set a default value to Y temporarily,
            completeData['reminderNotification'] = 'N'; //set a default value to N temporarily to force email notification,
            completeData['reminderTime'] = values['reminderTime'];
            completeData['timeZone'] = values['timeZone'];
            completeData['lastUpdatedBy'] = values['lastUpdatedBy'];
            completeData['reminderProps'] = values['reminderProps'];
            completeData['reminderRecurrence'] = values['reminderRecurrence'];

            if(completeData['recurrence'] === 'Y') {
                if(completeData.taskRecurrence.id) {
                    completeData.taskRecurrence.actionType = 'U';
                }
                else {
                    completeData.taskRecurrence.actionType = 'I';
                }
                completeData.taskRecurrence.repeatBy = taskRecurrence.repeatBy;
                completeData.taskRecurrence.repeatEvery = taskRecurrence.repeatEvery;
                completeData.taskRecurrence.repeatDays = taskRecurrence.repeatDays;
                completeData.taskRecurrence.startDateTime = taskRecurrence.startDateTime;
                completeData.taskRecurrence.endDateTime = taskRecurrence.endDateTime;
                completeData.taskRecurrence.status = 'Active'
            }
            else {
                if(completeData.taskRecurrence.id) {
                    delete completeData.taskRecurrence.repeatBy;
                    delete completeData.taskRecurrence.repeatEvery;
                    delete completeData.taskRecurrence.repeatDays;
                    delete completeData.taskRecurrence.startDateTime;
                    delete completeData.taskRecurrence.endDateTime;
                    delete completeData.taskRecurrence.status
                    completeData.taskRecurrence.actionType = 'D';
                }
                else {
                    delete completeData.taskRecurrence;
                }
            }
            

            if (values?.remindDate) {
                delete completeData.remindDate;
            }
            if (values?.remindTime) {
                delete completeData.remindTime;
            }
            if(completeData?.reminderOn === '') {
                delete completeData.reminderOn;
            } 
            if(completeData?.reminderRecurrence === 'N') {
                delete completeData.reminderProps;
            }
            delete completeData.taskTypeDesc;

            handleUpdate(completeData);
    }

    const handleUpdate = (data) => {
        dispatch(appActions.TASK_UPDATE_REQUEST(data))
    }

    const isFormFieldValid = (name) =>
        !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{formik.errors[name]}</small>
            )
        );
    };

    const getTaskTimeAllDayErrorMessage = () => {
        return (
            formik.touched['timeFrom'] && formik.errors['timeFrom'] && (
                <small className="p-error">{formik.errors['timeFrom']}</small>
            )
        );
    };

    const getFromToTimeOrAllDayErrorMessage = () => {
        const fromTime = formik.values.timeFrom;
        const toTime = formik.values.timeTo;
        let error = false;

        if(allDay && (fromTime !== '' && fromTime !== null && toTime !== '' && toTime != null))
        {
            setTimeFromToAllDayError(false);
            return error;
        }

        if (!(fromTime !== '' && fromTime != null && toTime !== '' && toTime !== null)) {
            setTimeFromToAllDayError(true);
            error = true;
        }
        else {
            setTimeFromToAllDayError(false);
        }

        return error;
    };

    const handleRepeatChange = (e) => {
        // formik.setFieldValue('recurrence', e.value);
        if(!validateRecurrence()) {
            return;
        }
        formik.setFieldValue('reminderRecurrence', e.value);
        if (e.value === 'Y') {
            const taskDate = formik.values.taskDate === '' ? moment(new Date()).format('DD-MM-YYYY') : moment(formik.values.taskDate).format('DD-MM-YYYY');
            const taskTime = formik.values.timeFrom === '' ? moment(new Date()).format('HH:mm:ss') : moment(formik.values.timeFrom).format('HH:mm:ss');
            const taskDateTime = moment(
                taskDate + ' ' + taskTime,
                dateTimeFormat
            ).toDate();
                                
            formik.setFieldValue('taskDate', taskDateTime);

            const dueDate = formik.values.dueDate === '' ? moment(new Date()).format('DD-MM-YYYY') : moment(formik.values.dueDate).format('DD-MM-YYYY');
            const dueTime = formik.values.timeTo === '' ? moment(new Date()).format('HH:mm:ss') : moment(formik.values.timeTo).format('HH:mm:ss');
            const dueDateTime = moment(
                dueDate + ' ' + dueTime,
                dateTimeFormat
            ).toDate();
                                
            formik.setFieldValue('dueDate', dueDateTime);
            // setRvisible(true);
            setReminderRecurrenceVisible(true);
        }
        else if (e.value === 'N') {
            setRecurrenceMessage('');
        }
    };

    const handleAssignTypeChange = (e) => {
        formik.setFieldValue('assignType', e.value);
        formik.setFieldValue('assignedTo', '');
        setSiteGroupMultiSelect([]);
    };

    const handleRecurrence = (data) => {
        const { repeatBy, startDateTime } = data;
        formik.setFieldValue('taskDate', moment(startDateTime, dateTimeFormat).toDate());
        formik.setFieldValue('repeatType', repeatBy);
        setTaskRecurrence(data);
        handleRecurrenceMessage(data);
        formik.setFieldValue('recurrence', 'Y');
    };

    const handleRepeatClick = (e) => {
        // const previousRecurrenceValue = formik.values.recurrence;
        const previousReminderRecurrenceValue = formik.values.reminderRecurrence;
        if(!validateRecurrence()) {
            return;
        }

        // if(previousRecurrenceValue === 'Y') {
        //     setRvisible(true);
        // }
        if(previousReminderRecurrenceValue === 'Y') {
            setReminderRecurrenceVisible(true);
        }
    }

    const handleRecurrenceMessage = (data) => {
        const repeatBy = data.repeatBy;
        const reminderEndDateTime = moment(data.endDateTime, dateTimeFormat).toDate()

        if(repeatBy === 'Hourly') {
            let strMsg = 'Occurs <strong class="p-5px"> every ' + data.repeatEvery + ' hours </strong> effective ' 
                + moment(data.startDateTime).format('DD MMM YYYY') 
                + ' until ' + moment(reminderEndDateTime).format('DD MMM YYYY') 
                + ' from ' + moment(data.startDateTime).format('h:mma')
                + ' to ' + moment(reminderEndDateTime).format('h:mma');
            setRecurrenceMessage(strMsg);
        }
        else if(repeatBy === 'Daily') {
            
            let strMsg = 'Occurs <strong class="p-5px"> every ' + data.repeatEvery + ' days </strong> effective ' 
            + moment(data.startDateTime).format('DD MMM YYYY') 
            + ' until ' + moment(reminderEndDateTime).format('DD MMM YYYY') 
            + ' from ' + moment(data.startDateTime).format('h:mma')
            + ' to ' + moment(reminderEndDateTime).format('h:mma');
            setRecurrenceMessage(strMsg);
        }
        else if(repeatBy === 'Weekly') {
            const arrRepeatDays = data.repeatDays.split(',').map(Number);
             // Map the numbers to weekday names using moment.js
             const dayNames = arrRepeatDays.map((day) => moment().isoWeekday(day).format('dddd'));

             // Join the array into a comma-separated string
             const formattedDays = data.repeatDays !== '' ? dayNames.join(', ') : '';
 
             let strMsg = 'Occurs <strong class="p-5px"> every ' + data.repeatEvery + ' </strong>weeks '
                 + formattedDays + ' effective ' 
                 + moment(data.startDateTime).format('DD MMM YYYY') 
                 + ' until ' + moment(reminderEndDateTime).format('DD MMM YYYY') 
                 + ' from ' + moment(data.startDateTime).format('h:mma')
                 + ' to ' + moment(reminderEndDateTime).format('h:mma');
             setRecurrenceMessage(strMsg);
        }
        else if(repeatBy === 'Monthly') {
            const dayPart = moment(data.startDateTime, "D/MM/YYYY").date();

            let strMsg = 'Occurs <strong class="p-5px"> day ' + dayPart + ' of every ' 
                + data.repeatEvery + ' months </strong> effective ' 
                + moment(data.startDateTime).format('DD MMM YYYY') 
                + ' until ' + moment(reminderEndDateTime).format('DD MMM YYYY') 
                + ' from ' + moment(data.startDateTime).format('h:mma')
                + ' to ' + moment(reminderEndDateTime).format('h:mma');
            setRecurrenceMessage(strMsg);
        }
        else if(repeatBy === 'Yearly') {
            // Parse the date string and format it as "MMMM D"
            const formattedDate = moment(data.startDateTime).format("MMMM D");

            let strMsg = 'Occurs <strong class="p-5px"> every ' + formattedDate 
                + ' </strong>effective ' 
                + moment(data.startDateTime).format('DD MMM YYYY') 
                + ' until ' + moment(reminderEndDateTime).format('DD MMM YYYY') 
                + ' from ' + moment(data.startDateTime).format('h:mma')
                + ' to ' + moment(reminderEndDateTime).format('h:mma');
            setRecurrenceMessage(strMsg);
        }
    };

    const validateRecurrence = () => {
        
        if(!formik.values.taskDate || !formik.values.dueDate || !formik.values.timeFrom || !formik.values.timeTo) {
            setRecurrenceErrorMsg('Start Date, Start Time, End Date, End Time is required.');
            return false;
        }
        else {
            setRecurrenceErrorMsg('');
            return true;
        }
        
    };

    const handleCancelRecurrence = () => {
        formik.setFieldValue('recurrence', 'N');
        setRecurrenceMessage('');
    };

    const handleReminderRecurrence = (data) => {
        const { repeatBy, startDateTime } = data;
        setRemindDateState(moment(startDateTime, dateTimeFormat).toDate());
        setRemindTimeState(moment(startDateTime, dateTimeFormat).toDate());
        formik.setFieldValue('reminderOn', moment(startDateTime, dateTimeFormat).toDate());
        formik.setFieldValue('repeatType', repeatBy);
        formik.setFieldValue('reminderProps', data);
        // setTaskRecurrence(data);
        setReminderPropsRecurrence(data);
        handleRecurrenceMessage(data);
        formik.setFieldValue('reminderRecurrence', 'Y');
    };

    const handleCancelReminderRecurrence = () => {
        formik.setFieldValue('reminderRecurrence', 'N');
        setRecurrenceMessage('');
    };

    const handleSearchUser = (user) => {
        // const { userGroupCode } = user;
        // formik.setFieldValue('assignedTo', user.userId);
        // if (userGroupCode) {
        //     let storeArr = userGroupCode.split(',');
        //     formik.setFieldValue('taskGroupCode', storeArr[0]);
        // }
        const { siteId } = user;
        setSelfAssign(false);
        formik.setFieldValue('assignedTo', user.userId);
        if (siteId) {
            let storeArr = siteId.split(',');
            formik.setFieldValue('siteId', storeArr[0]);
        }
    };

    const handleSearchOperatorName = (user) => {
        formik.setFieldValue('actionBy', user.userId);
    };

    const handleSearchSite = (site) => {
        const { siteId } = site;
        if (siteId) {
            formik.setFieldValue('assignedTo', siteId);
            formik.setFieldValue('siteId', siteId);
        }
    };

    const handleSiteAssignedTo = (siteId) => {
        formik.setFieldValue('assignedTo', siteId);
    };

    const handleSelfAssign = () => {
        const { siteId } = currentUser;
        setSelfAssign(true);
        formik.setFieldValue('assignedTo', storage.get('userId'));
        if (siteId) {
            let storeArr = siteId.split(',');
            formik.setFieldValue('siteId', storeArr[0]);
        }
    };

    const handleStartDateToRemindDate = (e) => {
        const value = e.value;
        formik.values.taskDate = value;
        setRemindDateState(value);
    };

    const handleStartTimeToRemindTime = (e) => {
        const value = e.value;
        formik.values.timeFrom = value;
        setRemindTimeState(value);
    };

    const handleRemindDate = (e) => {
        const value = e.value;
        setRemindDateState(value);
    };

    const handleRemindTime = (e) => {
        const value = e.value;
        setRemindTimeState(value);
    };

    const handleIntervalToRemindTime = (e) => {
        const value = e.value;

        formik.values.reminderTime = value;

        if(remindTimeState) {
            const regexMI  = /^(\d+)-MI$/; // Regex to check if input ends with "-MI" and has digits before it
            const regexHH = /^(\d+)-HH$/;  // Regex to check if input ends with "-HH"

            let match; 
            
            match = value.match(regexMI);
        
            if (match) {
            const minutesToAdd = parseInt(match[1], 10); // Extract the number before "-MI"
            const newDate = moment(remindTimeState).subtract(minutesToAdd, 'minutes').toDate(); // Add the minutes to current time
            setRemindTimeState(newDate); // Set the new time formatted
            return;
            }

            match = value.match(regexHH);
        
            if (match) {
            const hoursToAdd = parseInt(match[1], 10); // Extract the number before "-MI"
            const newDate = moment(remindTimeState).subtract(hoursToAdd, 'hours').toDate(); // Add hours to current time
            setRemindTimeState(newDate); // Set the new time formatted
            }
        }
    };

    const handleAllDay = (value) => {
        setAllDay(value);

        if(value) {
            if(formik.values.taskDate) {
                const taskDate = moment(formik.values.taskDate).format('DD-MM-YYYY');

                formik.values.timeFrom = moment(taskDate + ' 00:00', dateTimeFormat).toDate();

                formik.values.timeTo = moment(taskDate + ' 23:59', dateTimeFormat).toDate();

                formik.values.taskDate = formik.values.timeFrom;

                formik.values.dueDate = formik.values.timeTo;
            }
            else {
                const taskDate = moment(new Date()).format('DD-MM-YYYY');

                formik.values.timeFrom = moment(taskDate + ' 00:00', dateTimeFormat).toDate();

                formik.values.timeTo = moment(taskDate + ' 23:59', dateTimeFormat).toDate();

                formik.values.taskDate = formik.values.timeFrom;

                formik.values.dueDate = formik.values.timeTo;
            }
        }
        else {
            if(record.taskDateTime) {
                formik.values.taskDate = moment(record.taskDateTime, dateTimeFormat).toDate();
                formik.values.timeFrom = moment(record.taskDateTime, dateTimeFormat).toDate();
            }
            else {
                formik.values.timeFrom = '';
            }
            
            if(record.dueDateTime) {
                formik.values.dueDate = moment(record.dueDateTime, dateTimeFormat).toDate();
                formik.values.timeTo = moment(record.dueDateTime, dateTimeFormat).toDate();
            }
            else {
                formik.values.timeTo = '';
            }
        }
    };

    const handleConfirmDeleteDialog = async () => {
        if(!(record?.pid)) {
            setConfirmDeleteMessage(`Delete this message will affect other recurrence messages, do you wish to proceed ?`);
            setConfirmDeleteDialog(true);
        }
        else {
            handleDelete();
        }
    };

    const handleConfirmUpdateDialog = async (values) => {

        if(formik.values.assignType != null && formik.values.assignType === 'site-group') {
            const assignedTo = formik.values?.assignedTo || '';
        
            const params = {
                fetchSiteGroupCode: assignedTo
            }
            try {
                const response = await axios.get(`${configOpiton?.END_POINT}/communication/v1/sitegroup`, {
                    headers: {
                        'Authorization': storage.getToken()
                    },
                    params
                });

                if (response.status === 200) {
                    const siteGroups = response?.data?.data || '';
                    const concatenatedSiteNames = siteGroups.map(item => item.siteName).join(',');
                    setConfirmUpdateMessage(`Are you sure to send this message to Site Groups: ${concatenatedSiteNames}?`);
                    setConfirmUpdateDialog(true);
                }
            } catch (error) {
                console.error('Error retriving siteGroups:', error);
                
            }
        }
        else if (formik.values.assignType === 'site') {
            const assignedTo = formik.values?.assignedTo || '';
            
            const params = {
                fetchSiteCode: assignedTo
            }
            try {
                const response = await axios.get(`${configOpiton?.END_POINT}/communication/v1/site`, {
                    headers: {
                        'Authorization': storage.getToken()
                    },
                    params
                });

                if (response.status === 200) {
                    const sites = response?.data?.data || '';
                    const concatenatedSiteIds = sites.map(item => item.title).join(', ');
                    setConfirmUpdateMessage(`Are you sure to send this message to Sites: ${concatenatedSiteIds}?`);
                    setConfirmUpdateDialog(true);
                }
            } catch (error) {
                console.error('Error retriving sites:', error);
                
            }
        }
        else if (formik.values.assignType === 'site-all') {
            setConfirmUpdateMessage(`Are you sure to send this message to All Sites?`);
            setConfirmUpdateDialog(true);
        }
        else if (formik.values.assignType === 'user') {
            setConfirmUpdateMessage(`Are you sure to send this message to ${formik.values.assignedTo} ?`);
            setConfirmUpdateDialog(true);
        }
    };

    const handleSiteGroupMultiSelect = (value) => {
        const selectedValue = value;
        setSiteGroupMultiSelect(value);
        formik.setFieldValue('assignedTo', selectedValue?.join(',') || '');
    };

    return (
        <>
            <form onSubmit={formik.handleSubmit} className='mt-3'>
                <div className="grid formgrid mt-1">
                    {/* <div className="field col-4">
                        <label htmlFor="task" className="flex align-items-center required" >
                            <TaskFormIcon iconName={'task-type-icon.svg'} />
                            <span>Site Group</span>
                        </label>
                        <Dropdown
                            className="w-full"
                            id="taskType"
                            name="taskType"
                            value={formik.values.taskType}
                            options={taskOptions}
                            onChange={formik.handleChange}
                            placeholder="Choose task"
                        />
                         <MultiSelect 
                        id="taskType"
                        value={formik.values.taskType} 
                        onChange={(e) => formik.setFieldValue('taskType', e.value)} 
                        options={siteGroupOptions}
                        optionLabel="label" 
                        filter 
                        placeholder="Select Site Group" 
                        className="w-full"
                        maxSelectedLabels={3}  />

                        {getFormErrorMessage('taskType')}
                    </div> */}
                    
                    <div className="field col-6">
                        <label htmlFor="assignType" className="flex align-items-center required" > Audience </label>
                        <Dropdown
                            className="w-full"
                            id="assignType"
                            name="assignType"
                            value={formik.values.assignType}
                            options={actionTypeOptions}
                            onChange={(e) =>handleAssignTypeChange(e)}
                            placeholder="Audience"
                            optionLabel="name"
                            optionValue='code'
                        />
                        {getFormErrorMessage('assignType')}
                    </div>

                    
                    <div className="field col-6">
                        { formik.values.assignType !== 'site-all' &&
                        <label htmlFor="assignType" className="flex align-items-center required" >
                            <TaskFormIcon iconName={'assigned-to.svg'} />
                            <span className='mr-auto'>Assign to {formik.values.assignType === 'user' ? 'User' : formik.values.assignType === 'site-group' ? 'Site Group' : 'Site'}</span>
                           
                            { formik.values.assignType === 'user' && <span className="underline cursor-pointer floatRight" onClick={handleSelfAssign} > Assign to me </span>}
                        </label>
                        }
                        { formik.values.assignType === 'user' && 
                            <UserAutoCompleteInput handleSearchUser={handleSearchUser} selfAssign={selfAssign} currentUser={formik.values.assignedTo} />
                        }
                        { (formik.values.assignType === 'site') && 
                            <SiteAutoCompleteInput handleSiteAssignedTo={handleSiteAssignedTo} assignedTo={formik.values.assignedTo}/>
                        }
                        { formik.values.assignType === 'site-group' && 
                            <MultiSelect 
                                id="assignedTo"
                                value={siteGroupMultiSelect} 
                                onChange={(e) => handleSiteGroupMultiSelect(e.value)} 
                                options={siteGroupOptions}
                                optionLabel="label" 
                                filter 
                                placeholder="Select Site Group" 
                                className="w-full"
                                maxSelectedLabels={3} />
                        }
                        {getFormErrorMessage('assignedTo')}
                    </div>
                </div>
                
                <div className="grid formgrid">
                    <div className="field col-6 mt-1">
                        <label htmlFor="task" className="flex align-items-center required" >
                            <TaskFormIcon iconName={'task-title.svg'} />
                            <span>Message Subject</span>
                        </label>
                        <InputTextarea
                            className="w-full"
                            id="subject"
                            value={formik.values.subject}
                            onChange={formik.handleChange}
                            placeholder="Message Subject"
                            rows={2}
                            maxLength={48}
                        />
                        {getFormErrorMessage('subject')}
                    </div>
                    <div className="field col-6 mt-1">
                        <label htmlFor="task" className="flex align-items-center required" >
                            <TaskFormIcon iconName={'task-title.svg'} />
                            <span>Message Title</span>
                        </label>
                        <InputTextarea
                            className="w-full"
                            id="title"
                            value={formik.values.title}
                            onChange={formik.handleChange}
                            placeholder="Message Title"
                            rows={2}
                            maxLength={20}
                        />
                        {getFormErrorMessage('title')}
                    </div>
                    <div className="field col-12 mt-1">
                        <label htmlFor="task" className="flex align-items-center required">
                            <TaskFormIcon iconName={'description.svg'} />
                            <span>Message description</span>
                        </label>
                        <InputTextarea
                            className="w-full"
                            id="description"
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            placeholder="Message description"
                            rows={2}
                            maxLength={210}
                        />
                        {getFormErrorMessage('description')}
                    </div>
                </div>

                <div className="grid formgrid mt-1">

                    <div className="field col-4">
                        <label htmlFor="priority" className="flex align-items-center required">
                            <TaskFormIcon iconName={'priority-icon.svg'} />
                            <span>Priority</span>
                        </label>
                        <Dropdown
                            className="w-full"
                            id="priority"
                            value={formik.values.priority}
                            options={priorityOptions}
                            onChange={formik.handleChange}
                            placeholder="Priority"
                        />
                        {getFormErrorMessage('priority')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="impact" className="flex align-items-center required" > Impact </label>
                        <InputText className="w-full" id="impact" value={formik.values.impact} onChange={formik.handleChange} placeholder="impact"/>
                        {getFormErrorMessage('impact')}
                    </div>

                    {/* <div className="field col-4">
                        <label htmlFor="actionBy" className="flex align-items-center" > Operator Name </label>
                        <UserAutoCompleteInput handleSearchUser={handleSearchOperatorName}  currentUser={formik.values.actionBy} placeholderTxt='Search for Operator Name'/>
                        {getFormErrorMessage('actionBy')}
                    </div> */}

                <div className="field col-4">
                        <div className="grid formgrid mt-1">
                            <div className="field col-6">
                                <label htmlFor="task" className="flex align-items-center required">
                                    <TaskFormIcon iconName={'calendar-icon.svg'} />
                                    <span>Start Date</span>
                                </label>

                                <Calendar
                                    className="w-full"
                                    id="taskDate"
                                    value={formik.values.taskDate}
                                    onChange={(e) => handleStartDateToRemindDate(e)}
                                    placeholder="Date"
                                    minDate={new Date()}
                                    dateFormat="dd/mm/yy"
                                />
                                {getFormErrorMessage('taskDate')}
                            </div>
                            <div className="field col-6">
                                <label htmlFor="task" className="flex align-items-center required">
                                    <TaskFormIcon iconName={'clock-icon.svg'} />
                                    <span>Start Time</span>
                                </label>

                                <Calendar id="timeFrom" 
                                    value={formik.values.timeFrom} 
                                    showInput={true}
                                    onChange={(e) => handleStartTimeToRemindTime(e)} 
                                    timeOnly />
                                {getFormErrorMessage('timeFrom')}
                            </div>
                        </div>
                        {/* {getTaskTimeAllDayErrorMessage()} */}
                    </div>

                </div>

                <div className="grid formgrid mt-1">

                    <div className="field col-4">
                        <div className="grid formgrid mt-1">
                            <div className="field col-6">
                                <label htmlFor="task" className="flex align-items-center required">
                                    <TaskFormIcon iconName={'calendar-icon.svg'} />
                                    <span>End Date</span>
                                </label>

                                <Calendar
                                    className="w-full"
                                    id="dueDate"
                                    value={formik.values.dueDate}
                                    onChange={formik.handleChange}
                                    placeholder="Date"
                                    minDate={new Date()}
                                    dateFormat="dd/mm/yy"
                                />
                                {getFormErrorMessage('dueDate')}
                            </div>
                            <div className="field col-6">
                                <label htmlFor="task" className="flex align-items-center required">
                                    <TaskFormIcon iconName={'clock-icon.svg'} />
                                    <span>End Time</span>
                                </label>

                                <Calendar id="timeTo" 
                                    value={formik.values.timeTo} 
                                    showInput={true}
                                    onChange={formik.handleChange} 
                                    timeOnly />
                                {getFormErrorMessage('timeTo')}
                            </div>
                        </div>
                        
                    </div>

                    <div className="field col-4">
                            <label htmlFor="repeat" className="flex align-items-center required" >
                                <TaskFormIcon iconName={'clock-icon.svg'} />
                                <span>TimeZone</span>
                            </label>
                            <Dropdown
                                className="w-full"
                                id="timeZone"
                                value={formik.values.timeZone}
                                options={timeZoneOptions}
                                onChange={formik.handleChange}
                                placeholder="Select"
                            />
                            {getFormErrorMessage('timeZone')}
                    </div>

                    <div className="field col-2">
                        <label style={{ height: '15px' }}> </label>
                        <div className="flex w-full align-items-center gap-10 h-40">
                            <InputSwitch
                                className="mr-1"
                                checked={allDay}
                                onChange={(e) => handleAllDay(e.value)}
                            />
                            <label className="p-checkbox-label">All day</label>
                        </div>
                    </div>
                </div>

                <div className="grid formgrid mt-1 align-items-center">
                    <div className="field col-2">
                        <label htmlFor="repeat" className="flex align-items-center" >
                            <TaskFormIcon iconName={'repeat-type.svg'} />
                            <span>Message Recurrence</span>
                        </label>
                        {/* <Dropdown
                            className="w-full"
                            id="repeatType"
                            value={formik.values.recurrence}
                            options={recurrenceOptions}
                            onChange={handleRepeatChange}
                            onClick={handleRepeatClick}
                            placeholder="Select"
                        /> */}
                        <Dropdown
                                className="w-full"
                                id="recurrence"
                                value={formik.values.reminderRecurrence}
                                options={recurrenceOptions}
                                onChange={handleRepeatChange}
                                onClick={handleRepeatClick}
                                placeholder="Select"
                            />
                        {recurrenceErrorMsg && <small className="p-error">{recurrenceErrorMsg}</small>}
                    </div>
                    
                    <div className="col-10">
                        <label className="flex align-items-center" dangerouslySetInnerHTML={{ __html: recurrenceMessage }} ></label>
                    </div>

                </div>

                
                    
                <div className="grid formgrid mt-1">

                    {/* <div className="field col-4 pt-25">
                        <div className="flex align-items-center">
                            <InputSwitch
                                id="reminder"
                                name="reminder"
                                checked={formik.values.reminder}
                                onChange={formik.handleChange}
                            />
                            <label className="p-checkbox-label ml-2">
                                Reminder
                            </label>
                        </div>
                    </div> */}

                    

                    {/* { (formik.values.reminderTime === null || formik.values.reminderTime === 'CUSTOM-TIME') &&  */}
                        <div className="field col-4">
                            <div className="grid formgrid mt-1">
                                <div className="field col-6">
                                    <label htmlFor="task" className="flex align-items-center required">
                                        <TaskFormIcon iconName={'calendar-icon.svg'} />
                                        <span>Reminder Date</span>
                                    </label>

                                    <Calendar
                                        className="w-full"
                                        id="remindDate"
                                        value={remindDateState}
                                        onChange={(e) => handleRemindDate(e)}
                                        placeholder="Date"
                                        minDate={new Date()}
                                        dateFormat="dd/mm/yy"
                                        disabled={formik.values.reminderRecurrence !== 'N'}
                                    />
                                    {getFormErrorMessage('remindDate')}
                                </div>
                                <div className="field col-6">
                                    <label htmlFor="remindTime" className="flex align-items-center required">
                                        <TaskFormIcon iconName={'clock-icon.svg'} />
                                        <span>Reminder Time</span>
                                    </label>

                                    <Calendar id="remindTime" 
                                        value={remindTimeState} 
                                        showInput={true}
                                        onChange={(e) => handleRemindTime(e)} 
                                        disabled={formik.values.reminderRecurrence !== 'N'}
                                        timeOnly />
                                    {getFormErrorMessage('remindTime')}
                                </div>
                            </div>
                            
                        </div>
                    {/* } */}

                    <div className="field col-4">
                        <label htmlFor="reminderTime" className="flex align-items-center">
                            <i className="pi pi-clock mr-2" style={{ fontSize: '1rem' }} ></i>
                            <span>Reminder Interval</span>
                        </label>
                        <Dropdown
                            name="reminderTime"
                            value={formik.values.reminderTime}
                            options={reminderOptions}
                            onChange={(e) => handleIntervalToRemindTime(e)}
                            placeholder="Select a reminder"
                            className='w-full'
                            disabled={formik.values.reminderRecurrence !== 'N'}
                        />
                        {getFormErrorMessage('reminderTime')}
                    </div>

                    {/* <div className="field col-4">
                        <label htmlFor="attachmentRequired" className="flex align-items-center">
                            <TaskFormIcon iconName={'attachment-required.svg'} />
                            <span>Completion attachment</span>
                        </label>
                        <Dropdown
                            className="w-full"
                            id="attachmentRequired"
                            value={formik.values.attachmentRequired}
                            options={completionOptions}
                            onChange={formik.handleChange}
                            placeholder="Completion attachment"
                        />
                        {getFormErrorMessage('attachmentRequired')}
                    </div> */}
                    {/* {formik.values.attachmentRequired === "Y" && (

                        <div className="field col-4">
                            <label className='block' htmlFor="attachment">Attachment</label>
                            {attachment && attachment.fileName && (
                                <Chip label={attachment.fileName} removable onRemove={() => setAttachment('')} />
                            )}
                            {!attachment && (
                                <>
                                    <Button className="p-button-outlined" label="Upload" icon="pi pi-upload"
                                        onClick={() =>
                                            document.getElementById('file-upload').click()
                                        }
                                    />
                                    <input id="file-upload" type="file" onChange={handleFileUpload} style={{ display: 'none' }} />
                                </>
                            )}
                        </div>
                    )} */}
                 
                    <div className="field col-12">
                        <label htmlFor="remark" className="flex align-items-center">
                            Remark
                        </label>
                        <InputTextarea 
                            autoResize
                            className="w-full"
                            id="remark" 
                            value={formik.values.remark}
                            onChange={formik.handleChange}
                            rows={5} 
                            cols={30} />
                    </div>
                    <div className="field col-12">
                        <div className="flex justify-content-end mt-4 gap-10">
                          

                            <ConfirmDialog 
                                header="Update Confirmation"
                                style={{ width: '350px' }}
                                breakpoints={{ '1100px': '400px', '960px': '300px' }}
                                visible={confirmUpdateDialog} 
                                onHide={() => setConfirmUpdateDialog(false)} 
                                message={confirmUpdateMessage}
                                accept={handleUpdateFormik}
                            />

                            <Button
                                type="submit"
                                label="Update"
                                severity="basic"
                                className="p-button-primary"
                            />

                            {isAdminRole(userRole) && 
                                <div>
                                    <ConfirmDialog 
                                        header="Delete Confirmation"
                                        style={{ width: '350px' }}
                                        breakpoints={{ '1100px': '400px', '960px': '300px' }}
                                        visible={confirmDeleteDialog} 
                                        onHide={() => setConfirmDeleteDialog(false)} 
                                        message={confirmDeleteMessage}
                                        accept={handleDelete}
                                    />
                                    <Button label="Delete" 
                                        className="p-button-danger" 
                                        onClick={handleConfirmDeleteDialog} type="button"
                                        severity='danger' />
                                </div>
                            } 
                        </div>
                    </div>
                </div>
            </form>
            {/* <Dialog
                header="Message Recurrence"
                visible={rVisible}
                style={{ width: '450px' }}
                onHide={() => {
                    if (!rVisible) return;
                    setRvisible(false);
                    handleCancelRecurrence();
                }}
            >
                <RecurrenceForm
                    visible={setRvisible}
                    handleRecurrence={handleRecurrence}
                    recurrenceInfo={taskRecurrence}
                    taskDateTime={formik.values.taskDate}
                    handleCancelRecurrence={handleCancelRecurrence}
                />
            </Dialog> */}
            <Dialog header="Message Recurrence" visible={reminderRecurrenceVisible} style={{ width: '450px' }}
                onHide={() => {
                    if (!reminderRecurrenceVisible) return;
                    setReminderRecurrenceVisible(false);
                    handleCancelReminderRecurrence();
                }}
            >
                <ReminderRecurrenceForm 
                    visible={setReminderRecurrenceVisible} 
                    handleReminderRecurrence={handleReminderRecurrence} 
                    taskDateTime={formik.values.taskDate}
                    dueDateTime={formik.values.dueDate}
                    recurrenceInfo={reminderPropsRecurrence}
                    handleCancelReminderRecurrence={handleCancelReminderRecurrence}
                />
            </Dialog>
        </>
    );
};

const RecurrenceForm = (props) => {
    const { recurrenceInfo, taskDateTime, handleCancelRecurrence } = props;
    const [startDateTime, setStartDate] = useState(taskDateTime ? taskDateTime : new Date());
    const [repeatType, setRepeatType] = useState('Weekly');
    const [repeatEvery, setRepeatEvery] = useState(1.0);
    const [selectedDays, setSelectedDays] = useState([
        true,
        true,
        true,
        true,
        true,
        true,
        true,
    ]);
    const [endDate, setEndDate] = useState(new Date());
    const [endMinDate, setEndMinDate] = useState(null);
    const [repeatEveryError, setRepeatEveryError] = useState('');

    const repeatOptions = useSelector((state) => state.common.repeatList);

    const handleDaySelect = (index) => {
        const updatedDays = [...selectedDays];
        updatedDays[index] = !updatedDays[index];
        setSelectedDays(updatedDays);
    };

    const getRepeatDays = useCallback(() => {
        return selectedDays
            .map((day, index) => (day ? (index === 0 ? 7 : index) : null))
            .filter((day) => day !== null)
            .join(',');
    }, [selectedDays]);

    const handleRepeatChange = (e) => {
        const value = e.value;
        setRepeatType(value);
        if(value === 'Hourly') {
            const strTaskDate = moment(taskDateTime).format('DD-MM-YYYY');
            setStartDate(moment(taskDateTime, dateTimeFormat).toDate());
            const newEndMinDate = moment(strTaskDate + ' 23:59', dateTimeFormat).toDate();
            setEndMinDate(newEndMinDate);
            setEndDate(newEndMinDate);
        }
        setRepeatEvery(1);
    }

    const handleCancel = () => {
        props.visible(false);
        handleCancelRecurrence();
    }

    const handleSubmit = () => {
        if(repeatEvery <= 0) {
            setRepeatEveryError('Every value should not be less or equal to 0');
            return;
        }

        props.visible(false);

        let finalEndDate = moment(endDate).format(dateTimeFormat);

        if(repeatType === 'Hourly') {
            const strTaskDate = moment(taskDateTime).format('DD-MM-YYYY');
            const newEndMinDate = moment(strTaskDate + ' 23:59', dateTimeFormat).toDate();
            finalEndDate = moment(newEndMinDate).format(dateTimeFormat);
        }

        const recurrenceDetails = {
            startDateTime: moment(startDateTime).format(dateTimeFormat),
            repeatBy: repeatType,
            repeatEvery: repeatEvery,
            repeatDays: repeatType === 'Weekly' ? getRepeatDays() : repeatType === 'Monthly'? moment(startDateTime).format('DD') : '',
            endDateTime: finalEndDate,
            status: 'Active'
        };
        props.handleRecurrence(recurrenceDetails);
    };

    useEffect(() => {
        if (recurrenceInfo) {
            if(recurrenceInfo.repeatDays) {
                const previousSelectedDays = recurrenceInfo.repeatDays.split(',');
                const updatedDays = [...selectedDays];
                for(let i = 0; i < updatedDays.length; i++) {
                    updatedDays[i] = false;
                }

                for(let k = 0; k < previousSelectedDays.length; k++){
                    let index = previousSelectedDays[k];
                    if(index == 7)
                    {
                        updatedDays[0] = !updatedDays[0]; 
                    }
                    else {
                        updatedDays[index] = !updatedDays[index];
                    }
                }
                setSelectedDays(updatedDays);
            }
            if(recurrenceInfo.repeatBy) {
                setRepeatType(recurrenceInfo.repeatBy);
            }
            if(recurrenceInfo.repeatEvery) {
                setRepeatEvery(recurrenceInfo.repeatEvery);
            }
            
            if(recurrenceInfo.startDateTime) {
                const duration = repeatType === 'Daily' ? 'days' : repeatType === 'Weekly' ? 'weeks' : repeatType === 'Monthly' ? 'months' : repeatType === 'Years' ? 'years' : 'hours';
                setStartDate(moment(recurrenceInfo.startDateTime, dateTimeFormat).toDate());
                if(recurrenceInfo.endDateTime) {
                    const endDT = moment(recurrenceInfo.endDateTime, dateTimeFormat).toDate();
                    setEndMinDate(endDT);
                    setEndDate(endDT);
                }
                else {
                    const newEndMinDate = moment(recurrenceInfo.startDateTime, dateTimeFormat).add(recurrenceInfo.repeatEvery, duration).toDate();
                    setEndMinDate(newEndMinDate);
                    setEndDate(newEndMinDate);
                }
            }
            else if(taskDateTime) {
                const duration = repeatType === 'Daily' ? 'days' : repeatType === 'Weekly' ? 'weeks' : repeatType === 'Monthly' ? 'months' : repeatType === 'Years' ? 'years' : 'hours';
                setStartDate(taskDateTime);
                const newEndMinDate = moment(taskDateTime, dateTimeFormat).add(recurrenceInfo.repeatEvery, duration).toDate();
                setEndMinDate(newEndMinDate);
                setEndDate(newEndMinDate);
            }

        }
    }, [recurrenceInfo]);

    useEffect(() => {
        const duration = repeatType === 'Daily' ? 'days' : repeatType === 'Weekly' ? 'weeks' : repeatType === 'Monthly' ? 'months' : repeatType === 'Years' ? 'years' : 'hours';
        const newEndMinDate = moment(startDateTime, dateTimeFormat).add(repeatEvery, duration).toDate();
        setEndMinDate(startDateTime);
        // setEndDate(newEndMinDate);
    }, [repeatEvery, repeatType]);

    return (
        <div className="p-fluid p-formgrid p-grid">
            <div className="field col-12">
                <label htmlFor="start">Start</label>
                <Calendar
                    className="w-full"
                    id="start"
                    value={startDateTime}
                    onChange={(e) => setStartDate(e.value)}
                    dateFormat="dd/mm/yy"
                    disabled={repeatType === 'Hourly'}
                />
            </div>

            <div className="field col-12">
                <label htmlFor="repeat">Repeat</label>
                <Dropdown
                    id="repeat"
                    value={repeatType}
                    options={repeatOptions}
                    onChange={(e) => handleRepeatChange(e)}
                />
            </div>

            <div className="field col-12">
                <label htmlFor="repeatEvery">Every</label>
                {repeatType === 'Hourly' && <InputNumber
                    id="repeatEvery"
                    value={repeatEvery}
                    mode="decimal"
                    onChange={(e) => setRepeatEvery(e.value)}
                    minFractionDigits={1}
                    maxFractionDigits={1}
                    max={24}
                    suffix={' hour(s)'}
                />}
                {repeatType !== 'Hourly' && <InputNumber
                    id="repeatEvery"
                    value={repeatEvery}
                    onChange={(e) => setRepeatEvery(e.value)}
                    min={1}
                    suffix={repeatType === 'Daily' ? ' day(s)' : 
                        repeatType === 'Weekly' ? ' week(s)' : 
                        repeatType === 'Monthly' ? ' month(s)' : 
                        ' year(s)'}
                />}
                {repeatEveryError && 
                    <small className="p-error">{repeatEveryError}</small>
                }
            </div>

            {repeatType === 'Weekly' && (
                <div className="field col-12">
                    <label>On</label>
                    <div className="grid flex">
                        {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((day, index) => (
                            <ToggleButton
                                className="mr-1"
                                key={index}
                                onLabel={day}
                                offLabel={day}
                                checked={selectedDays[index]}
                                onChange={() => handleDaySelect(index)}
                                style={{ width: '2.5rem', marginRight: '0.5rem' }}
                            />
                        ))}
                    </div>
                </div>
            )}

            <Divider />

            <div className="field col-12">
                <label htmlFor="end">End</label>
                <Calendar
                    id="end"
                    value={endDate}
                    onChange={(e) => setEndDate(e.value)}
                    dateFormat="dd/mm/yy"
                    minDate={endMinDate}
                    disabled={repeatType === 'Hourly'}
                />
            </div>

            <div className="field col-12 p-text-center flex">
                <Button
                    label="Cancel"
                    className="p-button-secondary mr-2"
                    onClick={() => handleCancel()}
                />
                <Button label="Save" onClick={handleSubmit} />
            </div>
        </div>
    );
};

export default TaskFileUploadForm;
